export const UK_PHONE_REGEX = /^(?:\+?44|0)?(?:0)?(7\d{9})$/;

export function stripPhone(phone: string): string {
  return phone.replace(/[\s\-()]/g, "");
}

export function normalizeUKPhone(phone: string): string | null {
  const match = stripPhone(phone).match(UK_PHONE_REGEX);
  return match ? match[1]! : null;
}

export function formatUKPhoneForSMS(phone: string): string | null {
  const digits = normalizeUKPhone(phone);
  return digits ? `+44${digits}` : null;
}

// Every storage format a UK mobile may appear in across Booking.phone /
// QueueEntry.customerPhone rows (raw user input was never normalized before
// the customer portal). Used to match historical rows to a User account.
export function ukPhoneVariants(phone: string): string[] {
  const digits = normalizeUKPhone(phone);
  if (!digits) return [phone];
  return [digits, `0${digits}`, `+44${digits}`, `44${digits}`];
}
